import React__default, { useState, useEffect } from 'react';
import AtlasSelect from './AtlasSelect.js';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function AtlasAsyncSelect({
  asyncLoadHandler,
  isLoading = false,
  ...props
}) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(isLoading);
  const [filterText, setFilterText] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    const {
      signal
    } = controller;
    const fetchItems = async () => {
      setLoading(true);
      try {
        if (typeof asyncLoadHandler === 'function') {
          const response = await asyncLoadHandler({
            signal,
            filterText
          });
          if (response) {
            setItems(response.items);
          }
        } else if (asyncLoadHandler && typeof asyncLoadHandler.load === 'function') {
          const response = await asyncLoadHandler.load({
            signal,
            filterText
          });
          if (response) {
            setItems(response.items);
          }
        } else {
          console.error('Invalid asyncLoadHandler provided:', asyncLoadHandler);
        }
      } catch (error) {
        console.error('Error loading items:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchItems();
    return () => {
      controller.abort();
    };
  }, [asyncLoadHandler, filterText]);
  return /*#__PURE__*/React__default.createElement(AtlasSelect, _extends({
    isLoading: loading,
    inputValue: filterText,
    onInputChange: setFilterText,
    items: items
  }, props));
}
AtlasAsyncSelect.displayName = "AtlasAsyncSelect";

export { AtlasAsyncSelect };
